App.prototype.scrollTo = function(id) {

    var target = $(id);
	
	target = target.length ? target : $('[name=' + id.slice(1) +']');
	
	if (target.length) {
		$('html,body').animate({scrollTop: target.offset().top}, 1000);
		return false;
	}
}

App.addModule(function(app) {

    app.on('loaded', () => {

        $(document).on('click', '.smooth-scroll', function() {
		    app.scrollTo(this.hash);
	    })
    })
})
